import { VideoSubscribers } from './src/VideoSubscribers.js';

window.customElements.define('video-subscribers', VideoSubscribers);
